module.exports = __webpack_public_path__ + "img/004-telescope.b5e952bc.png";